import QTable from 'quasar/src/components/table/QTable.js';

export const adminContentItemResourceFinancialTableColumns = (): QTable['columns'] => [
  {
    name: 'price',
    field: 'price',
    label: 'قیمت کل',
    align: 'center',
    format: value => value?.toLocaleString() || value
  },
  {
    name: 'system_discount',
    field: 'system_discount',
    label: 'تخفیف سیستمی',
    align: 'center',
    format: value => value?.toLocaleString() || value
  },
  {
    name: 'manual_discount',
    field: 'manual_discount',
    label: 'تخفیف دستی',
    align: 'center'
  },
  {
    name: 'coupon_discount',
    field: 'coupon_discount',
    label: 'تخفیف هدیه',
    align: 'center',
    format: value => value?.toLocaleString() || value
  },
  {
    name: 'total_discount',
    field: 'total_discount',
    label: 'تخفیف کل',
    align: 'center',
    format: value => value?.toLocaleString() || value
  },
  {
    name: 'payable',
    field: 'payable',
    label: 'پرداخت شده',
    align: 'center',
    format: value => value?.toLocaleString() || value
  },
  {
    name: 'writer_share',
    field: 'writer_share',
    label: 'سهم نویسنده',
    align: 'center',
    format: value => value?.toLocaleString() || value
  },
  {
    name: 'profit',
    field: 'profit',
    label: 'سود',
    align: 'center'
  }
]